import { render, staticRenderFns } from "./SourceWithCount.vue?vue&type=template&id=5201621c&scoped=true&"
import script from "./SourceWithCount.vue?vue&type=script&lang=js&"
export * from "./SourceWithCount.vue?vue&type=script&lang=js&"
import style0 from "./SourceWithCount.vue?vue&type=style&index=0&id=5201621c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201621c",
  null
  
)

export default component.exports